export default __webpack_public_path__ + "static/media/walmart-logo.7464da0a.png";